import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/avatar-1.jpg"
import ConfigUrl, { axiosbaseurl } from "../../../config"
import secureLocalStorage from "react-secure-storage"
import { Modal } from "antd"
import { FaAngleDown } from "react-icons/fa"

const ProfileMenu = props => {
  const users = secureLocalStorage.getItem("User")

  const [menu, setMenu] = useState(false)
  const Navigate = useNavigate()

  const [username, setusername] = useState("Admin")

  const handleLogout = async e => {
    e.preventDefault()
    secureLocalStorage.removeItem("User")
    secureLocalStorage.removeItem("token")
    Navigate(`${ConfigUrl.appurl}login`)
  }

  const [ProfileModal, setModal] = useState(false)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={
              users?.profilePhoto
                ? `${ConfigUrl.imageurl}${users?.profilePhoto}`
                : user1
            }
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">
            {users?.userName}
          </span>
          {/* <i className="mdi mdi-chevron-down d-none d-xl-inline-block" /> */}
          <FaAngleDown />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem onClick={() => setModal(true)}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="#" onClick={e => handleLogout(e)} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      <Modal
        open={ProfileModal}
        onCancel={() => setModal(false)}
        footer={false}
        style={{ top: "1" }}
        title={
          <div className="d-flex align-items-center">
            <img
              className="rounded-circle me-2 header-profile-user"
              src={
                users?.profilePhoto
                  ? `${ConfigUrl.imageurl}${users?.profilePhoto}`
                  : user1
              }
              alt="Staff Avatar"
            />
            <span>Staff Profile Info</span>
          </div>
        }
      >
        <div className="Line " />
        <div className="px-3 pb-3">
          <div className="form-group">
            <label className="form-label fs-6">Name</label>
            <input
              className="form-control"
              disabled
              value={users?.userName}
            ></input>
          </div>
          <div className="form-group mt-3">
            <label className="form-label fs-6">Email</label>
            <input
              className="form-control"
              disabled
              value={users?.email}
            ></input>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProfileMenu))
